export default __webpack_public_path__ + "static/media/television.6502227a.jpg";